import { Box, Paper, Skeleton, Stack } from '@mui/material';

import { Container as DataGridContainer } from '../datagrid';

const columnWidths = ['5%', '40%', '40%', '40%', '40%', '40%', '40%', '40%', '40%', '15%'];

export const RequestListSkeleton = () => {
	return (
		<>
			<DataGridContainer sx={{ minHeight: 0 }}>
				<Paper
					sx={{
						borderRadius: 3,
						overflow: 'hidden',
						minHeight: '100%',
						height: '100%',
					}}
				>
					<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2 }}>
						<Skeleton variant="rounded" width={260} height={42} />
						<Stack direction="row" spacing={1.5}>
							<Skeleton variant="circular" width={32} height={32} />
							<Skeleton variant="circular" width={32} height={32} />
						</Stack>
					</Box>

					<Box
						sx={{
							display: 'grid',
							gridTemplateColumns: 'repeat(10, minmax(0, 1fr))',
							gap: 2,
							px: 2,
							py: 1.5,
							bgcolor: 'grey.100',
							borderTop: 1,
							borderBottom: 1,
							borderColor: 'divider',
						}}
					>
						{[
							'ID',
							'Name',
							'Phone',
							'User',
							'Employer',
							'Test Centre',
							'Assessment Date',
							'Payment Status',
							'Request Status',
							'Edit',
						].map((label) => (
							<Skeleton key={label} variant="text" width="85%" height={24} />
						))}
					</Box>

					<Box>
						{[...Array(10)].map((_, rowIndex) => (
							<Box
								// biome-ignore lint/suspicious/noArrayIndexKey: static items
								key={rowIndex}
								sx={{
									display: 'grid',
									gridTemplateColumns: 'repeat(10, minmax(0, 1fr))',
									gap: 2,
									px: 2,
									py: 2.25,
									alignItems: 'center',
									borderBottom: 1,
									borderColor: 'divider',
								}}
							>
								{columnWidths.map((width, columnIndex) => (
									<Skeleton
										// biome-ignore lint/suspicious/noArrayIndexKey: static items
										key={`${rowIndex}-${columnIndex}`}
										variant={columnIndex === 7 || columnIndex === 8 ? 'rounded' : 'text'}
										width={width}
										height={columnIndex === 7 || columnIndex === 8 ? 32 : 22}
									/>
								))}
							</Box>
						))}
					</Box>
				</Paper>
			</DataGridContainer>
		</>
	);
};
